module.exports = __webpack_public_path__ + "img/vizuro_logo.5140c706.png";